import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const PermissionsRoleActions = {
  onServerRoleUpdate: async ({ dispatch }) => {
    return dispatch('refreshUserModel', null, { root: true })
  },

  getPlatformRolesMatrix: async ({ commit }) => {
    return axiosRequest.
      get('/platform_roles/matrix').
      then(({ data }) => {
        commit('setPlatformRolesMatrix', data)
        return data
      }).
      catch(handleError)
  },

  togglePermissionForPlatformRole: async ({ dispatch }, { roleId, identifier }) => {
    return axiosRequest.
      patch(`/platform_roles/${roleId}/toggle_permission`, { identifier }).
      then(_ => dispatch('onServerRoleUpdate')).
      catch(handleError)
  },
}

export const PermissionsRoleMutations = {
  setPlatformRolesMatrix: (state, matrix) => {
    state.matrix = matrix
  },
}

export const PermissionsRoleGetters = {
  platformRolesMatrix: state => state.matrix,
}

export const PermissionsRoleState = {
  matrix: null,
}
